export default __webpack_public_path__ + "static/media/esperLogo.caead58e.gif";